import Skeleton from "../../common/Skeleton";

const ChartSkeleton = ({ isOrderBlock }: { isOrderBlock?: boolean }) => {
  return (
    <Skeleton
      className={`w-full ${isOrderBlock ? "h-[200px]" : "h-full"} rounded-md`}
    />
  );
};

export default ChartSkeleton;
